import { useContext } from 'react';
import { ThemeContext } from '../contexts';
export const useThemeContext = () => {
    const context = useContext(ThemeContext);
    if (context === null) {
        throw new Error('theme cannot be null in ThemeContextProvider');
    }
    const { theme, setColorScheme } = context;
    return Object.assign(Object.assign({}, theme), { setColorScheme });
};
//# sourceMappingURL=useThemeContext.js.map